module.exports = __webpack_public_path__ + "static/img/ir.23e0f96c.svg";